import { getScene7VideoRenditionURL } from '../impl/getScene7VideoRenditionUrl';
import { getImageSrcSet } from '../impl/getImageSrcSet';
import { getScene7ImageURL } from '../impl/getScene7ImageUrl';
export const defaultConfigValues = {
    defaultImageWidth: 800,
    maxWidth: 3000,
    maxHeight: 2000
};
export const defaultScene7ConfigValues = {
    previewObfuscationEnabled: false,
    previewLockingEnabled: false,
    liveObfuscationEnabled: true,
    liveLockingEnabled: true,
    forceLiveDomain: false
};
export class ImageServiceV1Impl {
    constructor(inputConfig, logger) {
        this.logger = logger;
        this.config = Object.assign(Object.assign(Object.assign({}, defaultConfigValues), inputConfig), { scene7Config: Object.assign(Object.assign({}, inputConfig.scene7Config), defaultScene7ConfigValues) });
    }
    getImageURL(requestedImage, requiredWidth, optionalParams) {
        return getScene7ImageURL(Object.assign(Object.assign({}, requestedImage), { params: optionalParams, imageSourceType: 'scene7' }), requiredWidth, this.config, this.logger);
    }
    getVideoRenditionURL(requestedRendition) {
        return getScene7VideoRenditionURL(requestedRendition, this.config);
    }
    getImageSrcSet(requestedImage, optionalParams) {
        return getImageSrcSet(this.config.maxWidth, width => {
            return getScene7ImageURL(Object.assign(Object.assign({}, requestedImage), { params: optionalParams, imageSourceType: 'scene7' }), width, this.config, this.logger);
        });
    }
}
